import { useDemoStore } from "@/pinia/index";
const store = useDemoStore();

const getApiUrl = () => {
  let api;
  if (store.context == 0) {
    api = "http://w-api.files99.com"; //测试环境 //测试地址;
    // api = "https://cn-w-api-produce.files99.com"; //中国
  } else if (store.context == 1) {
    if (store.server == "cn") {
      api = "https://cn-w-api-produce.files99.com"; //中国
    } else if (store.server == "de") {
      api = "https://de-w-api-produce.kernal.net"; //德国
    } else if (store.server == "usWest") {
      api = "https://us-w-api-produce.kernal.net"; //美国West
    } else if (store.server == "usEst") {
      api = "https://us-w-api-produce.kernal.net"; //美国Est
    } else if (store.server == "br") {
      api = "https://br-w-api-produce.kernal.net"; //巴西
    } else if (store.server == "sg") {
      api = "https://sg-w-api-produce.kernal.net"; //新加坡
    }
  } else if (store.context == 2) {
    if (store.server == "cn") {
      api = "https://cn-w-api-produce.files99.com"; //中国
    } else if (store.server == "de") {
      api = "https://de-w.salesdeep.com"; //德国
    } else if (store.server == "usWest") {
      api = "https://us-w.salesdeep.com"; //美国West
    } else if (store.server == "usEst") {
      api = "https://use-w.salesdeep.com"; //美国Est
    } else if (store.server == "br") {
      api = "https://br-w.salesdeep.com"; //巴西
    } else if (store.server == "sg") {
      api = "https://sg-w.salesdeep.com"; //新加坡
    }
  }
  return api;
};

export default getApiUrl;
